class DetailPublic {
    constructor() {
        document.addEventListener(
            "alpine:init",
            () => {
                Alpine.data("detailPublic", () => ({
                    currentIndex: 0,
                    video: { url: null },
                    embedVideoUrl: null,

                    init() {
                        window.alpineRender(this);
                        this.embedVideoUrl = this.toYoutubeNoCookieEmbedUrl(this.video?.url);
                    },
                    onSlideChange(event) {
                        const [swiper] = event.detail;
                        this.currentIndex = swiper.realIndex;
                    },
                    toYoutubeNoCookieEmbedUrl(rawUrl) {
                        if (!rawUrl || typeof rawUrl !== "string") {
                            return null;
                        }

                        const match = rawUrl.match(
                            /^https?:\/\/youtu\.be\/([a-zA-Z0-9_-]{11})$/,
                        );

                        if (!match) {
                            return null;
                        }

                        return `https://www.youtube-nocookie.com/embed/${match[1]}`;
                    },
                    parseYoutubeStart(url) {
                        const raw = url.searchParams.get("t") || "";

                        if (/^\d+$/.test(raw)) {
                            return parseInt(raw, 10);
                        }

                        const match = raw.match(
                            /^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?$/,
                        );

                        if (!match) {
                            return 0;
                        }
                        return (
                            parseInt(match[1] || "0", 10) * 3600 +
                            parseInt(match[2] || "0", 10) * 60 +
                            parseInt(match[3] || "0", 10)
                        );
                    },
                    closeDialogImg() {
                        document.querySelector(`[x-ref='dialogImg']`).close();
                        setTimeout(() => {
                            const swiperEl =
                                document.querySelector("swiper-container");
                            swiperEl.swiper.slideTo(0);
                        }, 250);
                    },
                }));
            },
            { once: true },
        );
    }
}

new DetailPublic();
